import moment from 'moment-timezone'
import liff from '@line/liff'
import i18n from '@/lang'

import { getPatientList } from '@/api/caregiver'
import { DEFAULT_TIMEZONE } from '@/util/helper'

const getDefaultState = () => (
  {
    loading: {
      status: false,
      time: null,
      orgData: null
    },
    lineUser: {
      isLoggedIn: false,
      profile: {
        userId: '',
        displayName: '',
        pictureUrl: '',
        statusMessage: ''
      },
      language: null
    },
    patientList: [],
    selectedPatientId: '',
    userInfo: {}
  }
)

const state = getDefaultState()

const getters = {
  getLineUser: state => {
    return state.lineUser
  },
  getPatientList: state => {
    return state.patientList
  },
  getUserInfo: state => {
    if (!getDefaultPatientId(state.patientList)) return null
    return state.patientList.find(item => item.id === state.selectedPatientId)
  },
  getSelectedPatientId: state => {
    return state.selectedPatientId
  },
  getDefaultPatientId: state => {
    return getDefaultPatientId(state.patientList)
  },
  getLoadingStatus: state => {
    return state.loading.status
  },
  getLoadingTime: state => {
    return state.loading.time
  }
}

const mutations = {
  SET_LINE_LOGGED_STATUS: (state, bool) => {
    state.lineUser.isLoggedIn = bool
  },
  SET_LINE_USER_PROFILE: (state, object) => {
    state.lineUser.profile = Object.assign(state.lineUser.profile, object)
  },
  SET_LOADING_INFO: (state, { status = false, time = new Date().getTime(), orgData = null }) => {
    state.loading.status = status
    state.loading.time = time
    state.loading.orgData = orgData
  },
  SET_PATIENT_LIST: (state, data) => {
    state.patientList = data
  },
  SET_SELECTED_PATIENT_ID: (state, patientId) => {
    if (state.selectedPatientId === patientId) return
    state.selectedPatientId = patientId
  },
  // 重置 state
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  initializeLiff ({ commit, state }) {
    return new Promise(async (resolve, reject) => {
      try {
        await liff.init({
          liffId: '1657266877-XaPKqOlx'
        })
        const isLoggedIn = await liff.isLoggedIn()
        commit('SET_LINE_LOGGED_STATUS', isLoggedIn)
        if (isLoggedIn) {
          const profile = await liff.getProfile()
          commit('SET_LINE_USER_PROFILE', profile)
        }
        resolve(state.lineUser)
      } catch (error) {
        resolve(error)
      }
    })
  },
  getPatientList ({ commit }, lineId) {
    return new Promise((resolve, reject) => {
      getPatientList(lineId)
        .then(response => {
          const { data = [] } = response

          if (data.length > 0) {
            data.forEach(item => {
              let genderStr = [i18n.t('formItemName.female'), i18n.t('formItemName.male')]
              item.gender = genderStr[item.gender]
              item.age = moment().diff(moment(item.birthday), 'year') || 0
              item.legType = item.affectiveSide
              item.affectiveSide = item.affectiveSide === 'left' ? i18n.t('formItemName.left') : i18n.t('formItemName.right')
              item.sameTimezone = item.timezone === DEFAULT_TIMEZONE
              item.isSoftwareOnlyMode = item.device.mac === '00:00:00:00:00:00'
            })

            commit('SET_PATIENT_LIST', data)
            commit('SET_SELECTED_PATIENT_ID', data[0].id)
            commit('SET_LOADING_INFO', { status: true, orgData: response.data })
          }

          resolve({ patientList: data })
        })
        .catch(error => reject(error))
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

function getDefaultPatientId (patientList) {
  const [ firstNormalListPatient ] = patientList
  if (firstNormalListPatient) return firstNormalListPatient.id
  return ''
}



// WEBPACK FOOTER //
// ./src/stores/modules/caregiver.js